import Dashboard from "./components/Dashboard";

export const routes = [{
    path: '/',
    name: 'Inicio',
    component: Dashboard,
    iconCls: 'el-icon-menu'
}, ];
